import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="row">
      <div className="col-sm-12 col-xl-6 offset-xl-3">
        <div className="d-flex flex-column justify-content-between align-items-center">
          <h1 className="text-center">404 Page Not Found</h1>

          <Link to={-1} className="btn btn-primary">
            Volver atrás
          </Link>
        </div>
      </div>
    </div>
  );
}
